import ErrorTip from "../shared/errorTip/errorTip";
import Label from "../shared/label/label";
import { stylizationWrapper } from "../shared/stylization";
import TextArea from "../shared/textarea/textarea";
import Wrapper from "../shared/wrapper/wrapper";
import { TextAreaFieldProps } from "./types/textAreaFieldProps";
import { labelProps } from "../shared/label/types/labelProps";
import { TipProps } from "../shared/errorTip/types/errorTipProps";
import { useEffect, useState } from "react";
import { ReactComponent as emergencyHome } from '../../icons/emergency_home.svg';
import { ReactComponent as cancel } from '../../icons/cancel.svg';
import { TextAreaProps, textareaCustomizedProps } from "../shared/textarea/types/textareaProps";
import { inputStateType, validation } from "../../helpers/validation/validation";

const TextAreaField = (props: TextAreaFieldProps) => {
    const [errorCautionDisplay, setErrorCautionDisplay] = useState('none');
    const [pristine, setPristine] = useState(props.pristine);
    const [ValidIcon, setValidIcon] = useState('none');
    const [inputState, setInputState] = useState('');
    const [errorText, setErrorText] = useState(props.tipText);

    var stylization = props.style !== undefined ? props.style : stylizationWrapper;

    const showError = () => {
        setErrorCautionDisplay('inline-block');
        setInputState(inputStateType.inputError);
    }

    const clearError = () => {
        setErrorCautionDisplay('none');
        setInputState('');
    }

    const showValid = () => {
        setValidIcon('inline-block');
        if (!props.keepPristine) setInputState(inputStateType.inputValid);
    }

    const clearValid = () => {
        setValidIcon('none');
        setInputState('');
    }

    const actionsForChange = (value: any) => {
        var errorText = validation(props.configValidation, value);
        if (errorText) {
            clearValid();
            setErrorText(errorText);
            showError();
        }
        else {
            setPristine(false);
            if (value) {
                clearError();
                showValid();
                setErrorText('');
            }
        }
    }

    useEffect(() => {
        if (props.validationError === true) {
            var errorText = validation(props.configValidation, props.value);
            if (errorText) {
                setErrorText(errorText);
                showError();
            } else {
                clearError();
                if (!pristine) showValid();
            }
        } else {
            clearError();
            if (!pristine) showValid();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.validationError, pristine, props.tipText, props.reload])

    useEffect(() => {
        if (!pristine) {
            actionsForChange(props.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])

    useEffect(() => {
        setPristine(props.pristine);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.pristine])

    const onChangeInput = (value: any, local: boolean = true) => {
        if (props.onFill) {
            const hasNewVal = Boolean(value);
            props.onFill(hasNewVal);
        }
        if (value !== props.value) {
            if (!local && props.setValue) {
                props.setValue(value);
            }
        }
        actionsForChange(value);
    }

    var textAreaProps: TextAreaProps = {
        placeholder: props.textAreaPlaceholder,
        className: `${inputState} ${props.textareaSharedProps?.className !== undefined ? props.textareaSharedProps?.className : ''}`,
        style: props.textareaSharedProps?.style,
        type: props.type,
        value: props.value,
        disabled: props.searching || props.disabled,
        onChange: onChangeInput,
        onFocus: props.onFocusText,
        onBlur: props.onBlurText,
    }

    var textareaCustomizedProps: textareaCustomizedProps = {
        props: textAreaProps,
        additionalIcon: props.additionalIcon,
        classNameIcon: inputStateType.iconValid,
        displayIcon: ValidIcon,
        searching: props.searching,
        dynamicResize: props.dynamicResize,
        addCommentBtn: props.addCommentBtn,
        textareaRef: props.textareaRef,
        onClickFilterComments: props.setCommentsFilter,
        isMarkedForCommentFilter: props.isMarkedForCommentFilter
    }

    var labelProps: labelProps = {
        style: {
            marginBottom: '10px',
            display: "inline-block"
        }
    }

    var tipProps: TipProps = {
        style: {
            display: errorCautionDisplay
        }
    }

    return (
        <Wrapper style={stylization} children={
            <>
                {props.labelName ? (<><Label {...labelProps} className='body-txt-medium' labelname={props.labelName} /> <br /></>) : null}
                <TextArea {...textareaCustomizedProps} />
                <ErrorTip props={tipProps} tipText={errorText} tipType={inputState === inputStateType.inputError ? 'errorTip' : undefined} additionalIcon={inputState === inputStateType.inputWarning ? emergencyHome : cancel}></ErrorTip>
            </>
        } />
    )
}

export default TextAreaField;